module.exports = __webpack_public_path__ + "static/img/main-01.a3a5e72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/main-01.jpg
// module id = 8+77
// module chunks = 1